function parseAspectRatio(aspectRatio) {
  if (!aspectRatio) {
    return void 0;
  }
  const indexOfSeparator = aspectRatio.indexOf(":");
  if (indexOfSeparator === -1) {
    console.warn(
      "parseAspectRatio(...): Unable to parse input '%s'",
      aspectRatio
    );
    return {
      width: 1,
      height: 1
    };
  }
  return {
    width: parseInt(aspectRatio.substring(0, indexOfSeparator), 10),
    height: parseInt(aspectRatio.substring(indexOfSeparator + 1), 10)
  };
}

export { parseAspectRatio };
//# sourceMappingURL=util.parse-aspect-ratio.js.map
